import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const DetailsLink = ({ onClickDetails }) => {
	const labels = useLabels();
	const detailLabel = labels.get('DETAILS');
	return (
		<button
			type="button"
			className="text-link text-decoration-underline text-link-muted"
			onClick={onClickDetails}
		>
			<span className="ddc-font-size-xsmall">{detailLabel}</span>
		</button>
	);
};

DetailsLink.propTypes = {
	onClickDetails: PropTypes.func
};

export default DetailsLink;
